<template>
  <div class="link" v-on:click="goToTable">
    {{ getDictionaryEntry("overlayInstallation.tableTask.link") }}
  </div>
</template>

<script>
export default {
  name: "LinkInstallationTaskPlanned",
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: null,
    };
  },
  beforeMount() {
    this.data = this.params.data;
  },
  methods: {
    goToTable() {
      this.$router.push({
        path: "aktuelle-eftersyn",
        query: { tableSearchQuery: this.data.id },
      });

      this.$store.dispatch("toggleOverlay");
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  height: 100%;
  cursor: pointer;
  font-size: 1.3rem;

  &:hover {
    color: var(--color-blue);
  }
}
</style>
